import { Id, projectReport } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, projectId: Id) {
  return getState().find((res) => res.reportId === projectId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectReportRequestFailure(uuid) {
      return queryState(getState, uuid)((res) => res.request.isFailure, false);
    },
    isRetrieveProjectReportRequestPending(uuid) {
      return queryState(getState, uuid)((res) => res.request.isPending, false);
    },
    isRetrieveProjectReportRequestSuccess(uuid) {
      return queryState(getState, uuid)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getProjectReport(uuid) {
      return queryState(getState, uuid)((res) => res.report, {
        ...projectReport,
        uuid,
      });
    },
  };
}

export { createSelector };
